import AppState, { POPUPS } from '@/js/AppState';
import { observer } from 'mobx-react-lite';
import PopupsManager from 'react-sdk/PopupsManager';


import HaxeBackend from '@/components/HaxeBackend/HaxeBackend';
import classes from './ScreenGame.module.css';

import PopupMinigameSequence from '@/components/popups/PopupMinigameSequence/PopupMinigameSequence';
import PopupMinigameStars from '@/components/popups/PopupMinigameStars/PopupMinigameStars';
import Minigames from '@/js/Minigames/Minigames';
import SequenceScenario from '@/js/SequenceScenario';
import clsx from 'clsx';
import PopupCatalogue from '@/components/popups/PopupCatalogue/PopupCatalogue';
import Characters from '@/components/Dial/Characters';
import CatalogueButton from '@/components/Hud/CatalogueButton/CatalogueButton';
import { pickRandom } from 'react-sdk/utils';
import Catalogue from '@/js/Catalogue/Catalogue';
import PopupCatalogueItem from '@/components/popups/PopupCatalogueItem/PopupCatalogueItem';
import ObjectiveBar from '@/components/ObjectiveBar/ObjectiveBar';
import Chrono from '@/components/Hud/Chrono/Chrono';
import PopupModuleStars from '@/components/popups/PopupModuleStars/PopupModuleStars';
import GameOverlay from './GameOverlay';
import PopupFTUE from '@/components/popups/PopupFTUE/PopupFTUE';
import PopupMinigameIntro from '@/components/popups/PopupMinigameIntro/PopupMinigameIntro';
import AudioButton from '@/components/Hud/AudioButton/AudioButton';

const ScreenGame = () => {

  //let overlayVisible = useMemo(() => { PopupsManager.someOpened || AppState.dials || Minigames.current}, [PopupsManager.someOpened, AppState.dials, Minigames.current] )
  let overlayVisible = (PopupsManager.someOpened || (AppState.dials && AppState.dials.currentDial) || Minigames.current)


  return (
    <div className={classes.ScreenGame}>

      <HaxeBackend visible={AppState.haxeBackendVisible}/>

      <div className={clsx(classes.top_hud, !AppState.UI_visibilities.game_header && classes.invisible, AppState.lockHud && classes.locked)} >

        <div className={classes.top_hud_buttons}>
          {/* <div className={classes.hud_menu_btn}><Button icon={<FaBars />} /></div> */}
          {/* <div className={classes.hud_mail_btn}><Button icon={<FaEnvelopeOpenText />} /></div> */}

        </div>
      </div>

      {Catalogue.unlocked.length > 0 &&
      <CatalogueButton />}

      {AppState.objectives.activeRootObjectives.length > 0 &&
      <div className={classes.objbar}>
        <ObjectiveBar  />
      </div>}

      <Chrono />

      <AudioButton /> 

      {AppState.debugMode &&
      <div className={classes.debug}>
        <details>
          <summary>DEBUG</summary>
          <div>
            <button onClick={() => {
              let item = pickRandom(Catalogue.all.filter(i => i.locked))
              Catalogue.unlock(item.id, () => {console.log("closed")})
            }}>unlock random catalogue item</button>
            <button onClick={() => {Catalogue.multiUnlock(["mur-gouttereau","meneau","semelle-isolee","semelle-profonde",], () => {console.log("FINI")})}
            }>unlock multi items</button>

            <button onClick={() => {AppState.showEndScreen()}
            }>Ecran de fin</button>
            <button onClick={() => AppState.dials.playSequence("data/dials.data", "c1_introduction")}>play dial</button>
            <ol>
              {Minigames.all
              .filter(mg => !mg.line.get("parent"))
              .map(mg => (
              <li>
                <button onClick={() => Minigames.play(mg.id, () => {})}>Play minigame {mg.id}</button>
              </li>))}
            </ol>
            <button onClick={() => PopupsManager.open(POPUPS.NOTIF, {
              title: "TEST", text: "ABWABWA", onClose: () => PopupsManager.close(POPUPS.NOTIF)
            })}>NOTIF</button>


            {/* <button onClick={() => SequenceScenario.playSequence("dis_bureauTrash")}>OPEN BUREAU TRASH</button>
            <button onClick={() => SequenceScenario.playSequence("dis_magasinPeinture")}>OPEN MAGASIN PEINTURE</button>
            <button onClick={() => SequenceScenario.playSequence("dis_universite")}>OPEN UNIVERSITE</button>
            <button onClick={() => SequenceScenario.playSequence("dis_laboHope")}>OPEN LABO</button>
            <button onClick={() => SequenceScenario.next()}>SequenceScenario.next</button> */}

            {/* <button onClick={() => {
              AppState.currentMeeting.customActivityCommand("RefreshObjectives", AppState.teamObjectivesActivityId, false, { "Group" : AppState.team.groupId })
            }}>REFRESH TEAM OBJECTIFS</button> */}

          </div>



        </details>
      </div>}

      {overlayVisible && <GameOverlay forDial={(AppState.dials && AppState.dials.currentDial && !PopupsManager.isOpened(POPUPS.MODULE_STARS))} />}

      {Minigames.current &&
      <PopupMinigameSequence />}

      {PopupsManager.isOpened(POPUPS.MINIGAME_STARS) &&
      <PopupMinigameStars />}

      {PopupsManager.isOpened(POPUPS.MODULE_STARS) &&
      <PopupModuleStars debriefText={AppState.moduleDebriefText} onClose={AppState.moduleDebriefOnClose} />}

      {PopupsManager.isOpened(POPUPS.CATALOGUE) &&
      <PopupCatalogue />}
      {PopupsManager.isOpened(POPUPS.CATALOGUE_ITEM) &&
      <PopupCatalogueItem />}

      {PopupsManager.isOpened(POPUPS.MINIGAME_INTRO) &&
      <PopupMinigameIntro />}

      {PopupsManager.isOpened(POPUPS.FTUE) &&
      <PopupFTUE />}


      <Characters dials={AppState.dials} />
    </div>
  );
};

export default observer(ScreenGame);
